import { put, select, takeLatest } from 'redux-saga/effects'
import { BodySurveyConstants } from '../store/bodySurvey.constants'
import { IBodyParts, IBodySurveyState } from '../store/bodySurvey.types'
import { getBodySurveySelector } from '../selectors'
import { setSelectedBodyPartData } from '../store/bodySurvey.actions'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* setBodyParts() {
  const bodySurvey: IBodySurveyState = yield select(getBodySurveySelector)
  const { __selectedBodyPart, __selectedBodyParts } = bodySurvey
  try {
    if (__selectedBodyPart?.isDisabled) return
    let updatedBodyPart: IBodyParts[] = []
    const filterExaminedBodyParts = __selectedBodyParts.filter((parts) => !parts.isExamined)

    const partIndex = filterExaminedBodyParts.findIndex((part) => part.id === __selectedBodyPart?.id)
    if (partIndex !== -1) {
      updatedBodyPart = filterExaminedBodyParts.filter((part) => part.id !== __selectedBodyPart?.id)
    } else {
      if (__selectedBodyPart) {
        updatedBodyPart = [...filterExaminedBodyParts, __selectedBodyPart]
      }
    }
    const removedZoomBodyParts = updatedBodyPart.filter((parts) => !parts.hasZoom)
    yield put(setSelectedBodyPartData(removedZoomBodyParts))
  } catch (e) {
    yield put(throwPcrException(`setBodyParts() error: ${e}`))
  }
}

export function* setBodyPartsSaga() {
  yield takeLatest([BodySurveyConstants.SET_SELECTED_BODY_PART], performWithMutexHOG, setBodyParts)
}
